import { message } from "antd";
import {
  showConstituencyPopup,
  partyColors,
  showRegionalPopup,
  transformGeoData,
  formatLiveFeatureData,
  calculateTotalVotesByCandidate,
  processElectionParliamentaryResults,
  createSeatsVisualization,
} from "./functions";
import { ElectionCharts } from "./visuals";
import { types } from ".";
import parties from "../services/parties.json";
import candidates from "../services/candidates.json";
import parliamentaryCandiates from "../services/parliamentaryCandidates.json"

const electionCharts = new ElectionCharts();

export class MapFx {
  map: any;
  wind: any = window;

  vdcId: string;
  tucId: string;
  vvcId: string;
  chartIndex: number;

  loadData: (data: { regional: types.RegionalData[] }) => void;

  selectedYear: string = "";
  isWorldMapActive: any = false; // Initial map view state
  constituencyLayer: any = null; // Reference to the constituency GeoJSON layer
  currentGeoJsonLayer: any = null; // Reference to the region GeoJSON layer

  constructor(mapConfig: {
    mapId: string;
    vdcId: string;
    tucId: string;
    vvcId: string;
    chartIndex: number;
    loadData: (data: { regional: any }) => void;
  }) {
    this.vdcId = mapConfig.vdcId;
    this.tucId = mapConfig.tucId;
    this.vvcId = mapConfig.vvcId;
    this.chartIndex = mapConfig.chartIndex;
    this.loadData = mapConfig.loadData;
    try {
      this.map = this.wind["L"].map(mapConfig.mapId, {
        center: [7.95, -1.03], // Coordinates for Ghana's center
        zoom: 6, // Adjust zoom level to fit the whole country
        zoomSnap: 0.1,
        zoomDelta: 0.5,

        boxZoom: true,
        doubleClickZoom: true,
        minZoom: 6, // Ensure you can zoom out enough to see the whole country
      });

      const zoomToFitControl = this.wind["L"].control({ position: "topright" });

      zoomToFitControl.onAdd = () => {
        const button = this.wind["L"].DomUtil.create(
          "button",
          "zoom-to-fit-button leaflet-bar leaflet-control"
        );
        button.innerHTML = "Zoom to Fit";
        button.style.cursor = "pointer";
        button.style.padding = "5px 10px";
        button.style.backgroundColor = "#252525";
        button.style.color = "#fff";
        button.style.border = "1px solid #ccc";
        button.style.borderRadius = "5px";

        // Attach click event to fit bounds
        button.onclick = () => {
          if (this.map && this.currentGeoJsonLayer) {
            this.map.fitBounds(this.currentGeoJsonLayer.getBounds());
          } else {
            console.log("GeoJSON Layer is not loaded!");
          }
        };

        return button;
      };

      // // Toggle View Control
      // const toggleViewControl = this.wind["L"].control({
      //   position: "topright",
      // });

      // toggleViewControl.onAdd = () => {
      //   const container = this.wind["L"].DomUtil.create(
      //     "div",
      //     "toggle-view-control leaflet-bar leaflet-control"
      //   );

      //   // Create a button element
      //   const button = this.wind["L"].DomUtil.create("button", "", container);
      //   button.innerHTML = "Toggle View";
      //   button.style.cursor = "pointer";
      //   button.style.padding = "5px 10px";
      //   button.style.backgroundColor = "#ff0200";
      //   button.style.color = "white";
      //   button.style.border = "1px solid #ccc";
      //   button.style.borderRadius = "5px";

      //   // Toggle view on button click

      //   let isRegionalView = true;
      //   button.onclick = async () => {
      //     if (isRegionalView) {
      //       button.innerHTML = "Show Regional";
      //       await this.loadConstituencyGeoJson("ALL", "view");
      //     } else {
      //       button.innerHTML = "Show Constituencies";
      //       await this.loadGeoJsonForYear(this.selectedYear, "view");
      //     }
      //     isRegionalView = !isRegionalView;
      //   };

      //   return container;
      // };

      // Add layer control
      const baseMaps = {
        "Street Map": this.wind["L"].tileLayer(
          "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        ),
        "Satellite Map": this.wind["L"].tileLayer(
          "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        ),
      };

      const overlayMaps = {
        "GeoJSON Layer": this.currentGeoJsonLayer, // Dynamic overlay layer
      };

      // // Toggle view
      // toggleViewControl.addTo(this.map);

      //Zoom Fit
      zoomToFitControl.addTo(this.map);

      this.wind["L"].control.layers(baseMaps, overlayMaps).addTo(this.map);
    } catch (e) {}
  }

  removeMap() {
    this.map && this.map.off();
    this.map && this.map.remove();
  }
  renderPartyCandidatesList = (partyCandidates: any, totalVotes: any) => {
    console.log(partyCandidates);
    const container = document.getElementById("party-candidates-list");
    if (!container) {
      console.error("Party candidates container not found!");
      return;
    }

    // Clear existing content
    container.innerHTML = "";
    // Iterate through the sorted list of party candidates
    // @ts-ignore
    partyCandidates.forEach(({ candidate, votes, color, img, party_name }) => {
      // Calculate the percentage of total votes
      const percentage = votes && totalVotes ?  ((votes / totalVotes) * 100).toFixed(1) : 0;
      // Candidate container
      const candidateDiv = document.createElement("div");
      candidateDiv.className = "flex justify-between items-center gap-4 my-4";

      // Candidate image
      const imageDiv = document.createElement("div");
      imageDiv.className = "bg-img rounded-full h-[67px] w-[67px]";
      imageDiv.style.backgroundColor = color;
      imageDiv.style.border = `3px solid ${color}`;
      imageDiv.style.backgroundImage = `url(${img})`;
      imageDiv.style.backgroundSize = "cover";

      // Candidate details
      const detailsDiv = document.createElement("div");
      detailsDiv.className = "w-11/12";

      // Header section for candidate details
      const headerDiv = document.createElement("div");
      headerDiv.className = "flex justify-between";

      // Candidate percentage and votes
      const percentageDiv = document.createElement("div");
      percentageDiv.className = "flex gap-2 items-center";
      percentageDiv.style.color = color;
      percentageDiv.innerHTML = `
      <div class="text-2xl font-bold">${percentage}%</div>
      <div class="text-sm">${candidate
        .replaceAll("_", " ")
        .toLocaleUpperCase()} <span class="font-bold text-lg ml-4">${party_name}</span</div>
    `;

      // Total votes text
      const votesDiv = document.createElement("div");
      votesDiv.className = "text-sm";
      votesDiv.textContent = `Votes: ${votes}`;

      // Append percentage and votes to header
      headerDiv.appendChild(percentageDiv);
      headerDiv.appendChild(votesDiv);

      // Progress bar
      const progressBar = document.createElement("div");
      progressBar.className =
        "h-[20px] bg-gray-200 rounded-lg mt-2 overflow-hidden";
      const progressFill = document.createElement("div");
      progressFill.style.width = `${percentage}%`;
      progressFill.style.backgroundColor = color;
      progressFill.className = "h-full";
      progressBar.appendChild(progressFill);

      // Append elements to detailsDiv
      detailsDiv.appendChild(headerDiv);
      detailsDiv.appendChild(progressBar);

      // Append elements to candidateDiv
      candidateDiv.appendChild(imageDiv);
      candidateDiv.appendChild(detailsDiv);

      // Append candidateDiv to the container
      container.appendChild(candidateDiv);
    });
  };






  loadGeoJsonForYear = async (selectedYear: string, view: string) => {
    if (!selectedYear) {
      message.error("No year selected");
      return;
    }
    this.clearLayers();
    this.selectedYear = selectedYear;

    try {
      const response = await fetch(
        `data/geojson/${view}/Regional/regional_${selectedYear}.geojson`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      let data = await response.json();
      data.features = transformGeoData(data);
      const self = this;
      this.loadData({
        regional: (data.features || [])
          .filter((feature: any) => feature.properties)
          .map((feature: any) => feature.properties),
      });

      // Remove the old GeoJSON layer if it exists
      if (this.currentGeoJsonLayer) {
        this.map.removeLayer(this.currentGeoJsonLayer);
      }

      // Clear any existing constituency layers
      if (this.constituencyLayer) {
        this.map.removeLayer(this.constituencyLayer);
        this.constituencyLayer = null;
      }

      // Clear charts when loading new year
      electionCharts.clearCharts(this.vdcId, this.tucId, this.vvcId, this.chartIndex);

      // Add the new GeoJSON data to the map
      this.currentGeoJsonLayer = this.wind["L"]
        .geoJSON(data, {
          style: function (feature: any) {
            const props = feature.properties;

            const entries = Object.entries(props.partyvotes);
            entries.forEach(([key, value]) => {});

            const winningParty = props["winner.party"];
            // return { color: feature.properties.color || 'brown' }; // Default color
            return {
              color: "black", // Border color
              weight: 1, // Border width
              fillColor:
                partyColors[winningParty as keyof typeof partyColors] ||
                "#252525", // Default grey if no match
              fillOpacity: 0.7, // Transparency
            };
          },
          onEachFeature: function (feature: any, layer: any) {
            const regionName = feature.properties.region;
            if (!regionName) {
              message.error(
                "Region name is missing in the GeoJSON properties."
              );
              return;
            }
            layer
              .bindTooltip(feature.properties.region, {
                permanent: true,
                direction: "center",
                className: "region-label",
              })
              .openTooltip();

            let clickTimer: any;
            layer.on("click", function () {
              if (clickTimer) {
                clearTimeout(clickTimer); // Cancel single-click action if double-click happens
              }
              clickTimer = setTimeout(() => {
                const props = layer.feature.properties;
                showRegionalPopup(layer, props);
              }, 300);

              electionCharts.updateCharts(layer.feature.properties, self.chartIndex);
            });

            layer.on("dblclick", function () {
              clearTimeout(clickTimer);
              self.map.doubleClickZoom.disable();

              if (self.currentGeoJsonLayer) {
                self.currentGeoJsonLayer.eachLayer((l: any) => {
                  l.setStyle({
                    Color: "#ccc",
                    weight: 1,
                  });
                });
              }
              self.loadConstituencyGeoJson(regionName, view);
              layer.setStyle({
                Color: "black",
                weight: 1,
              });

              layer.closeTooltip();
              const bounds = layer.getBounds();
              self.map.fitBounds(bounds);
            });
          },
        })
        .addTo(this.map);

      // Adjust the map to fit the new GeoJSON data
      this.map.fitBounds(this.currentGeoJsonLayer.getBounds());
    } catch (error) {
      message.error("Error loading GeoJSON");
      this.loadData({
        regional: [],
      });
    }
  };

  // Function to load constituency GeoJSON for a region
  loadConstituencyGeoJson = async (regionName: string, view: string) => {
    if (!regionName) {
      message.error("Region name is required to load constituencies.");
      return;
    }

    try {
      const response = await fetch(
        `data/geojson/${view}/Constituency/constituency_${this.selectedYear}.geojson`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      data.features = transformGeoData(data);
      const self = this;

      // Filter constituencies for the selected region
      const filteredFeatures = data.features.filter(
        (feature: any) =>
          feature.properties.region.toUpperCase() === regionName.toUpperCase()
      );

      if (filteredFeatures.length === 0) {
        console.warn(`No constituencies found for the region: ${regionName}`);
        return;
      }

      // Remove the existing constituency layer if it exists
      if (this.constituencyLayer) {
        this.map.removeLayer(this.constituencyLayer);
      }

      // Add the new constituency GeoJSON layer
      this.constituencyLayer = this.wind["L"]
        .geoJSON(filteredFeatures, {
          style: function (feature: any) {
            const props = feature.properties;

            const winningParty = props["winner.party"];
            return {
              color: "black", // Border color
              weight: 1, // Border width
              fillColor:
                partyColors[winningParty as keyof typeof partyColors] ||
                "#cccccc", // Default grey if no match
              fillOpacity: 0.7, // Transparency
            };
          },
          onEachFeature: (feature: any, layer: any) => {
            const constituency_name =
              feature.properties?.const_name ||
              feature.properties?.constituency_name;

            // Show constituency tooltip
            let isTooltipOpen = false;
            layer.on("click", function () {
              if (isTooltipOpen) {
                layer.closeTooltip();
                isTooltipOpen = false;
              } else {
                layer
                  .bindTooltip(constituency_name, {
                    permanent: true,
                    direction: "center",
                    className: "constituency-label",
                  })
                  .openTooltip();
                isTooltipOpen = true;
              }
            });

            layer.on("dblclick", function () {
              const bounds = layer.getBounds();
              self.map.fitBounds(bounds);
              // Update charts with constituency data
              const props = layer.feature.properties;
              showConstituencyPopup(layer, props);
              electionCharts.updateCharts(props, self.chartIndex);
            });
          },
        })
        .addTo(this.map);
    } catch (error) {
      console.log("error:", error);
      message.error("Error loading constituency GeoJSON");
    }
  };

  loadLiveConstituencyGeoJson =async ( view: string,electionResults:any) => {
    try {
      const response = await fetch(
          `data/geojson/${view}/Constituency/constituency_2024.geojson`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      let data = await response.json();
      data.features = transformGeoData(data);
      const self = this;
      // Remove the old GeoJSON layer if it exists
      if (this.currentGeoJsonLayer) {
        this.map.removeLayer(this.currentGeoJsonLayer);
      }
      // Clear any existing constituency layers
      if (this.constituencyLayer) {
        this.map.removeLayer(this.constituencyLayer);
        this.constituencyLayer = null;
      }
      const overallPartyVotes = calculateTotalVotesByCandidate(candidates, electionResults,parties);
      const totalVotes = overallPartyVotes.reduce((acc,canditdate) => acc + canditdate.votes,0 )
      this.renderPartyCandidatesList(overallPartyVotes,totalVotes);
      this.currentGeoJsonLayer = this.wind["L"]
          .geoJSON(data, {
            style: function (feature: any) {
              return {
                color: "black", // Border color
                weight: 1, // Border width
                fillColor:
                    "#e8e8e8", // Default grey if no match
                fillOpacity: 0.7, // Transparency
              };
            },
            onEachFeature: async  function (feature: any, layer: any) {
              const constituencyName = feature.properties.const_name;
              if (!constituencyName) {
                message.error(
                    "constituencyName  is missing in the GeoJSON properties."
                );
                return;
              }
              const electionResultByConstCode  = (electionResults || []).filter((result: any) => result.const_code === feature.properties.const_code)
              feature.properties = formatLiveFeatureData(feature,electionResultByConstCode,candidates);
              const winningParty = feature.properties["winner.party"]
              layer.setStyle({
                color: "black", // Border color
                weight: 1, // Border width
                fillColor: partyColors[winningParty?.toLocaleUpperCase() as keyof typeof partyColors] || "#e8e8e8",
                fillOpacity: 0.7, // Transparency
              });
              layer.on("click",async () => {
                console.log(feature.properties.const_code)
                const bounds = layer.getBounds();
                self.map.fitBounds(bounds);
                layer
                    .bindPopup(`<p style="font-size:large"> ${feature.properties.const_name}</p><p>Double Click Constituency For Results</p>`, {
                      className: "constituency-popup",
                      maxWidth: 350,
                    })
                    .openPopup();
              });
              layer.on("dblclick", async function () {
                try {
                  const props = layer.feature.properties;
                  showConstituencyPopup(layer, props);
                } catch (error) {
                  console.error("Failed to fetch constituency results", error);
                  message.error("Error loading constituency results.");
                }
              });
            },
          })
          .addTo(this.map);

      // Adjust the map to fit the new GeoJSON data
      this.map.fitBounds(this.currentGeoJsonLayer.getBounds());
    } catch (error) {
      console.log(error);
      message.error("Error loading GeoJSON");
    }
  };

  loadLiveConstituencyParliamentaryGeoJson =async ( view: string,electionResults:any) => {
    try {
      const response = await fetch(
          `data/geojson/${view}/Constituency/constituency_2024.geojson`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      let data = await response.json();
      data.features = transformGeoData(data);
      const self = this;
      // Remove the old GeoJSON layer if it exists
      if (this.currentGeoJsonLayer) {
        this.map.removeLayer(this.currentGeoJsonLayer);
      }
      // Clear any existing constituency layers
      if (this.constituencyLayer) {
        this.map.removeLayer(this.constituencyLayer);
        this.constituencyLayer = null;
      }
      const winners = processElectionParliamentaryResults(data.features,electionResults,parties)
      createSeatsVisualization(winners)
      this.currentGeoJsonLayer = this.wind["L"]
          .geoJSON(data, {
            style: function (feature: any) {
              return {
                color: "black", // Border color
                weight: 1, // Border width
                fillColor:
                    "#e8e8e8", // Default grey if no match
                fillOpacity: 0.7, // Transparency
              };
            },
            onEachFeature: async  function (feature: any, layer: any) {
              const constituencyName = feature.properties.const_name;
              if (!constituencyName) {
                message.error(
                    "constituencyName  is missing in the GeoJSON properties."
                );
                return;
              }
              const electionResultByConstCode  = (electionResults || []).filter((result: any) => result.const_code === feature.properties.const_code)
              feature.properties = formatLiveFeatureData(feature,electionResultByConstCode,parliamentaryCandiates);
              const winningParty = feature.properties["winner.party"]
              layer.setStyle({
                color: "black", // Border color
                weight: 1, // Border width
                fillColor: partyColors[winningParty?.toLocaleUpperCase() as keyof typeof partyColors] || "#e8e8e8",
                fillOpacity: 0.7, // Transparency
              });
              layer.on("click",async () => {
                console.log(feature.properties.const_code)
                const bounds = layer.getBounds();
                self.map.fitBounds(bounds);
                layer
                    .bindPopup(`<p style="font-size:large"> ${feature.properties.const_name}</p><p>Double Click Constituency For Results</p>`, {
                      className: "constituency-popup",
                      maxWidth: 350,
                    })
                    .openPopup();
              });
              layer.on("dblclick", async function () {
                try {
                  const props = layer.feature.properties;
                  showConstituencyPopup(layer, props);
                } catch (error) {
                  console.error("Failed to fetch constituency results", error);
                  message.error("Error loading constituency results.");
                }
              });
            },
          })
          .addTo(this.map);

      // Adjust the map to fit the new GeoJSON data
      this.map.fitBounds(this.currentGeoJsonLayer.getBounds());
    } catch (error) {
      console.log(error);
      message.error("Error loading GeoJSON");
    }
  };

  clearLayers() {
    // Remove the existing layers
    const self = this;
    this.map.eachLayer(function (layer: any) {
      if (layer instanceof self.wind["L"].TileLayer) {
        self.map.removeLayer(layer);
      }
      if (layer instanceof self.wind["L"].GeoJSON) {
        self.map.removeLayer(layer);
      }
    });
    // Clear charts when layers are cleared
    electionCharts.clearCharts(this.vdcId, this.tucId, this.vvcId, this.chartIndex);
  }
}
